import { lazy } from 'react';

const CompanyCreate = lazy(() => import('./CompanyCreate'));

export default CompanyCreate;
